<template>
    <div v-if="status == 'successReceiptData'" class="money-request-bg">
        <div v-if="receiptData.user_full_name"  class="container pt-4 mb-5">
            <kt-col lg="12" md="12" xs="12" class="text-center mt-5 mb-3" style="text-align: center">
                <img v-if="receiptData.site_logo"
                     style="max-height: 200px; max-width: 200px; text-align: center"
                     :src="receiptData.site_logo"
                     alt="logo"
                >
            </kt-col>
            <table class="table border money-req-border-table">
                <thead>
                <tr>
                    <td>{{ $t('money_request.payment_result') }}</td>
                    <td
                        v-if="receiptData.payment_status == moneyRequestPaymentStatus.SUCCESS"
                        class="success font-weight-bold"
                    >
                        {{ $t('money_request.payment_success') }}
                    </td>
                    <td
                        v-if="receiptData.payment_status == moneyRequestPaymentStatus.FAIL"
                        class="danger font-weight-bold"
                    >
                        {{ $t('money_request.payment_fail') }}
                    </td>
                </tr>
                </thead>
                <tbody>
                <tr v-if="receiptData.payment_status == moneyRequestPaymentStatus.SUCCESS || receiptData.payment_status == moneyRequestPaymentStatus.FAIL">
                    <td>{{ $t('money_request.bank_tracking_number') }}</td>
                    <td>{{ receiptData.bank_tracking_number }}</td>
                </tr>
                <tr>
                    <td>{{ $t('money_request.request_from') }}</td>
                    <td>{{ receiptData.user_full_name }}</td>
                </tr>
                <tr>
                    <td>{{ $t('money_request.payer_name') }}</td>
                    <td>{{ receiptData.payer_name }}</td>
                </tr>
                <tr>
                    <td>{{ $t('money_request.request_hashid') }}</td>
                    <td>{{ receiptData.request_hashid }}</td>
                </tr>
                <tr>
                    <td>{{ $t('money_request.tracking_number') }}</td>
                    <td>{{ receiptData.tracking_number }}</td>
                </tr>
                <tr>
                    <td>{{ $t('money_request.pay_amount') }}</td>
                    <td>{{ receiptData.amount + ' ' + $t('currency.rial') }}
                        <span style="color:limegreen;">
                        {{
                                ' + ('
                                + receiptData.payer_wage + ' ' + $t('currency.rial')
                                + ' ' + $t('money_request.payer_wage') + ')'
                            }}
                    </span>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('label.date_payed') }}</td>
                    <td>{{ receiptData.date_payed }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <kt-panel v-else>
            <kt-panel-body>
                <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                    {{ $t('message.payment_page_not_found') }}
                </p>
            </kt-panel-body>
        </kt-panel>
    </div>
    <loader v-else></loader>
</template>

<script>

import Loading from '@/components/custom/loading'
import {mapGetters} from "vuex";
import {moneyRequestPaymentStatus} from '@/constants/moneyRequestPaymentStatus'

export default {
    name: 'money-request-receipt',
    
    components: {
        'loader': Loading
    },
    data() {
        return {
            'tracking_code': this.$route.params.tracking_code,
            moneyRequestPaymentStatus: moneyRequestPaymentStatus
        }
    },
    computed: {
        ...mapGetters('moneyRequest', [
            'status',
            'receiptData'
        ])
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('moneyRequest/receiptData', vm.tracking_code)
        })
    },
}

</script>

<style scoped>
.money-request-bg {
    background: url("./assets/credit-bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin: auto;
    width: 100%;
    height: 100%;
}
.money-req-border-table{
    border: 1px solid #b9c1d6 !important;
}
table.money-req-border-table td {
    border-top: 1px solid #b9c1d6 !important;
}
.success {
    color: darkgreen;
    background-color: lightgreen;
}.danger {
     color: darkred;
     background-color: lightpink;
 }

</style>